<template>
  <nuxt-link v-if="to" :to="to">
    <FixedAspect :ratio="1" class="hover:shadow-xl bg-white">
      <div class="flex flex-col justify-center">
        <CldnImg v-if="imageSrc" :src="imageSrc" :alt="alt" width="384" :ratio="1" crop="fit" />
      </div>
    </FixedAspect>
    <div class="fluid-xs leading-tightest pt-4 pb-2 font-medium text-center">{{ label }}</div>
  </nuxt-link>
</template>
<script>
import CldnImg from '@/components/CldnImg'
import FixedAspect from '@/components/common/FixedAspect'

export default {
  components: {
    CldnImg,
    FixedAspect
  },
  props: {
    imageSrc: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: null
    },
    to: {
      type: [Object, String],
      default: null
    },
    label: {
      type: String,
      default: null
    }
  }
}
</script>
